import BaseClient from './BaseClient';

class AdminCloningTargetsClient extends BaseClient {
    getCloningTargets(params, config) {
        const url = '/api/admin/cloning-targets';
        const method = 'get';

        return this.makeCoreApiRequest(url, method, null, params, config);
    }

    getCloningTargetsCount() {
        const url = '/api/admin/cloning-targets/count';
        const method = 'get';

        return this.makeCoreApiRequest(url, method, null);
    }

    getCloningTarget(cloningTargetId) {
        const method = 'get';
        const url = `/api/admin/cloning-targets/${cloningTargetId}`;

        return this.makeCoreApiRequest(url, method);
    }

    createCloningTarget(data) {
        const method = 'post';
        const url = `/api/admin/cloning-targets`;

        return this.makeCoreApiRequest(url, method, data);
    }

    updateCloningTarget(cloningTargetId, data) {
        const method = 'put';
        const url = `/api/admin/cloning-targets/${cloningTargetId}`;

        return this.makeCoreApiRequest(url, method, data);
    }

    deleteCloningTarget(cloningTargetId) {
        const method = 'delete';
        const url = `/api/admin/cloning-targets/${cloningTargetId}`;

        return this.makeCoreApiRequest(url, method);
    }
}

export default new AdminCloningTargetsClient();
